"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

// Taken from Loadable to support webpack 3 & 4 dynamic import compatibility.
// We need this because Loadable.renderResolved() is overridden by this render prop
function resolveImport(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

var makeAsyncPickerContent = function makeAsyncPickerContent(loader) {
  var AsyncPickerContentLoader = (0, _Loadable.default)({
    delay: 500,
    loader: loader,
    render: function render(result, props) {
      var AsyncPickerContent = resolveImport(result);
      var pickerRef = props.pickerRef,
          rest = (0, _objectWithoutProperties2.default)(props, ["pickerRef"]);
      return _react.default.createElement(AsyncPickerContent, (0, _extends2.default)({
        ref: pickerRef
      }, rest));
    },
    ErrorComponent: function ErrorComponent() {
      return _react.default.createElement(_UIErrorMessage.default, {
        illustration: "errors/icecream",
        illustrationProps: {
          width: 150
        },
        title: _I18n.default.text('emojiPickerAddon.loadablePicker.errorTitle')
      }, _react.default.createElement("p", null, _I18n.default.text('emojiPickerAddon.loadablePicker.errorMessage')));
    }
  });

  var AsyncPickerContentWithFocus =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(AsyncPickerContentWithFocus, _Component);

    function AsyncPickerContentWithFocus() {
      (0, _classCallCheck2.default)(this, AsyncPickerContentWithFocus);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AsyncPickerContentWithFocus).apply(this, arguments));
    }

    (0, _createClass2.default)(AsyncPickerContentWithFocus, [{
      key: "focus",
      value: function focus() {
        if (this.pickerRef && this.pickerRef.focus) {
          this.pickerRef.focus();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        return _react.default.createElement(AsyncPickerContentLoader, (0, _extends2.default)({}, this.props, {
          pickerRef: function pickerRef(el) {
            _this.pickerRef = el;
          }
        }));
      }
    }]);
    return AsyncPickerContentWithFocus;
  }(_react.Component);

  AsyncPickerContentWithFocus.preload = AsyncPickerContentLoader.preload;
  return AsyncPickerContentWithFocus;
};

var _default = makeAsyncPickerContent;
exports.default = _default;
module.exports = exports.default;